import { DrawableMediaHandle } from '../../../../subject/testRunner/media/MediaData';

export class LazyStimulusContent {
  constructor(public readonly handle: DrawableMediaHandle) {}
}
